import cloneDeep from 'lodash/cloneDeep';

import {
  SET_PENDING_ORDERS,
  SET_ORDERS,
  SET_WIDGET_TITLE,
  SET_SELECTED_ORDER,
  SET_SELECTED_ORDER_ID,
  SET_NUMBER_POOL,
  SET_NUMBER_POOLS, 
  SET_NUMBER_POOL_REFERENCES,
  SET_CHECK_REFERENCES_TEXT,        
  SET_SELECTED_NUMBER_POOL,
  SET_USER_VISIBLE_COLUMNS,
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR,
  SET_ACCOUNT_SETTINGS,
  SET_DAY_STATS,
  SET_MONTH_STATS,
  SET_NUMBER_AVAILABLE_COUNTRIES,
} from './mutationTypes';

import {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError
} from '@/store/helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_NUMBER_AVAILABLE_COUNTRIES](state, countries) {
    state.numberCountries = countries;
  },
  [SET_PENDING_ORDERS](state, pendingOrders) {
    state.pendingOrders = pendingOrders;
  },
  [SET_ORDERS](state, orders) {
    state.orders = orders;
  },
  [SET_SELECTED_ORDER](state, order) {
    state.selectedOrder = order;
  },
  [SET_SELECTED_ORDER_ID](state, orderId) {
    state.selectedOrderId = orderId;
  },
  [SET_NUMBER_POOL](state, { index, updatedNumberPool }) {
    const arrayToUpdate = cloneDeep(state.numberPools);
    arrayToUpdate[index] = updatedNumberPool;
    state.numberPools = arrayToUpdate;
  },
  [SET_NUMBER_POOLS](state, numberPools) {
    state.numberPools = numberPools;
  },
  [SET_SELECTED_NUMBER_POOL](state, numberPool) {
    state.selectedNumberPool = numberPool;
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns || []; 
  },
  [SET_NUMBER_POOL_REFERENCES](state, numberPoolReferences) {
    state.numberPoolReferences = numberPoolReferences;
  },
  [SET_CHECK_REFERENCES_TEXT](state, checkReferencesText) {
    state.checkReferencesText = checkReferencesText;
  },
  [SET_WIDGET_TITLE](state, title) {
    state.widget.title = title;
  },
  [SET_ACTION_STATUS_PENDING](state, { actionName }) {
    state.status[actionName] = { status: 'pending' };
  },
  [SET_ACTION_STATUS_SUCCESS](state, { actionName }) {
    state.status[actionName] = { status: 'success' };
  },
  [SET_ACTION_STATUS_ERROR](state, { actionName, error }) {
    state.status[actionName] = { status: 'error', error };
  },
  [SET_ACCOUNT_SETTINGS](state, accountSettings ) {
    state.accountSettings = accountSettings;
  },
  [SET_DAY_STATS](state, dayStats) {
    state.dayStats = dayStats;
  },
  [SET_MONTH_STATS](state, monthStats) {
    state.monthStats = monthStats;
  },
};